module.exports = __webpack_public_path__ + "img/ec.718f78f6.jpg";